import { MailIcon } from '@heroicons/react/outline'
import React from 'react'
import SectionHeading from '../../HomePage/SectionHeading'
import GradientButton from '../../Buttons/GradientButton'

const ContactSection = ({ onApplyClick }) => {
    return (
        <div className="flex flex-col items-center justify-center bg-white">
            <SectionHeading size="xl">
                Have questions or need assistance? <br /> Contact us:
            </SectionHeading>
            <div className="flex items-center space-x-2 my-6">
                <MailIcon className="h-8 w-8 text-olm" />
                <a
                    href="mailto:info@openlettermarketing.com"
                    className="font-medium">
                    Email: info@openlettermarketing.com
                </a>
            </div>
            <div className="w-96 max-w-full px-4">
                <GradientButton onClick={onApplyClick}>
                    Join Now And Start Earning
                </GradientButton>
            </div>
            <p className="text-center text-black max-w-lg mt-8">
                Join our affiliate program today and start earning while making
                a difference in the real estate industry. We look forward to
                partnering with you!
            </p>
        </div>
    )
}

export default ContactSection
